export const UPDATE_LINK_PAGE_VIEW = 'UPDATE_LINK_PAGE_VIEW'
export const UPDATE_LINK_PAGE_VIEW_SUCCESS = 'UPDATE_LINK_PAGE_VIEW_SUCCESS'
export const UPDATE_LINK_PAGE_VIEW_FAILURE = 'UPDATE_LINK_PAGE_VIEW_FAILURE'
export const UPDATE_LINK_PAGE_VIEW_CANCEL = 'UPDATE_LINK_PAGE_VIEW_CANCEL'
